import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let TaskMarker = class TaskMarker extends Vue {
    render(h) {
        return h("a-input", { props: {
                disabled: true
            } });
    }
};
tslib_1.__decorate([
    Prop({ default: {} })
], TaskMarker.prototype, "control", void 0);
TaskMarker = tslib_1.__decorate([
    Component({ name: 'TaskMarker' })
], TaskMarker);
export default TaskMarker;
